const files = require.context('.', true, /\.js$/)

let plugins = []

files.keys().forEach(key => {
  if (key === './index.js') return
  plugins.push(files(key).default)
})

export default plugins
